<template>
    <v-layout row wrap>
        <v-flex xs12 class="pa-5">
            <h2>{{$route.params.id}}</h2>
        </v-flex>
        <v-flex xs12>
            <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs md3 v-for="(product, index) in productsOfCategory" :key="index">
                        <v-card style="border-radius: 10px">
                            <v-img height="150px"
                                   :src="product.productImg"
                                   :lazy-src="product.productImg"
                                   aspect-ratio="1"
                            >
                            </v-img>
                            <v-card-actions>
                                <v-layout row wrap class="pr-3 pl-3 pt-2 pb-2">
                                    <v-flex xs12 class="pa-1" style="line-height: 30px">
                                        <div><b>{{product.productName}}</b></div>
                                        <div class="primary--text">{{product.productProducer}}</div>
                                        <div class="">{{product.soldAs}} ({{product.soldAsOf}})</div>
                                    </v-flex>
                                    <v-flex xs12 class="pa-2">
                                        <div><span style="font-size: 20px">{{product.productPrice | currency}}</span></div>

                                        <v-layout row xs12  wrap align-center class="">
                                            <v-btn medium block dark class="primary" @click="addToCart(product)"><b>Ajoutez</b> <v-icon small right>shopping_cart</v-icon></v-btn>
                                            <v-btn icon><v-icon>favorite_outline</v-icon></v-btn>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-flex>
    </v-layout>
</template>

<script>
  export default {
    computed: {
      productsOfCategory () {
        return this.$store.getters.productsOfCategory(this.$route.params.id)
      }
    },
    created () {
      console.log(this.$store.getters.productsOfCategory() + '=================')
    },
    name: 'Index'
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/produits/productCategories/Index.vue